import { Box, Typography } from '@mui/material';

import './index.css';

// samples use the exact colours the usage bars draw with (UsageLineRep, FloorUsageBar)
const CEILING_KEY: { color: string, label: string }[] = [
    { color: '#1B51A7', label: 'Used' },
    { color: '#C2C7E3', label: 'Remaining' },
    { color: '#FFCC00', label: 'Over quota threshold' },
    { color: '#CC3300', label: 'Over max quota' },
];

const FLOOR_KEY: { className: string, label: string }[] = [
    { className: 'floor_usage--fill--ok', label: 'Above minimum' },
    { className: 'floor_usage--fill--alert', label: 'Below minimum' },
    { className: 'floor_usage--fill--exceed', label: 'Action triggered' },
    { className: 'floor_usage--bar--suppressed', label: 'Not evaluated' },
];

interface UsageLegendProps {
    // the Min Rule key only matters to users who can see floors
    showFloor: boolean;
}

export function UsageLegend(props: UsageLegendProps) {
    const { showFloor } = props;
    return (
        <Box className='usage_legend'>
            <Typography className='usage_legend--title'>▲ Max Rule</Typography>
            <Box className='usage_legend--items'>
                {CEILING_KEY.map(k => <span key={k.label} className='usage_legend--item'>
                    <span className='usage_legend--swatch' style={{ background: k.color }} />{k.label}
                </span>)}
            </Box>
            {showFloor && <>
                <Typography className='usage_legend--title usage_legend--title--spaced'>▼ Min Rule</Typography>
                <Box className='usage_legend--items'>
                    {FLOOR_KEY.map(k => <span key={k.label} className='usage_legend--item'>
                        <span className={`usage_legend--swatch ${k.className}`} />{k.label}
                    </span>)}
                </Box>
            </>}
        </Box>
    );
}
